import {Link} from 'react-router-dom'
import type {
  FleetSite,
  MarketView,
  SiteDashboard,
  SiteStatus,
} from '../../types/kaldflyte'
import {StatusBadge} from '../common/StatusBadge'

export function SiteCard({
  status,
  metadata,
  dashboard,
  market,
}: {
  status: SiteStatus
  metadata: FleetSite
  dashboard: SiteDashboard | null
  market: MarketView | null
}) {
  const active = Boolean(status.active_event)
  const alarmCount = dashboard?.active_alarms.length ?? 0
  return (
    <Link className="site-card" to={`/sites/${encodeURIComponent(status.site_id)}`}>
      <div className="site-card-head">
        <div>
          <span className="eyebrow">{metadata.portfolio_id}</span>
          <h2>{status.site_id}</h2>
        </div>
        <StatusBadge tone={active ? 'critical' : 'neutral'}>
          {active ? 'Dispatch active' : 'Standby'}
        </StatusBadge>
      </div>
      <div className="site-card-metrics">
        <SiteMetric label="TTL" value={`${status.ttl_minutes.toFixed(0)} min`} />
        <SiteMetric
          label="Confidence"
          value={`${status.confidence_pct.toFixed(0)}%`}
        />
        <SiteMetric
          label="Predicted reduction"
          value={
            status.available_capacity_kW == null
              ? 'unknown'
              : `${status.available_capacity_kW.toFixed(0)} kW / ${status.capacity_dispatch_duration_minutes?.toFixed(0) || '?'} min`
          }
        />
        <SiteMetric label="Alarms" value={String(alarmCount)} />
      </div>
      <div className="site-card-footer">
        <StatusBadge tone="info">
          {market?.provider_name || metadata.provider_name || 'Provider unknown'}
        </StatusBadge>
        {metadata.simulation_mode || dashboard?.simulation_mode ? (
          <StatusBadge tone="warning">Simulation</StatusBadge>
        ) : null}
      </div>
    </Link>
  )
}

function SiteMetric({label, value}: {label: string; value: string}) {
  return (
    <div>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  )
}
